import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { useTranslate } from '@im/react-localization';
import BidDetails from '../../BidDetails/BidDetails';
import Box from '@mui/material/Box';
import { useSearchParams } from 'react-router-dom';
import { StyledText, StyledTextSub } from 'src/components/StyledTypography';
import LaunchIcon from '@mui/icons-material/Launch';
import IconButton from '@mui/material/IconButton';

export default function DetailsDialog(props: Readonly<{ item: any }>) {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode');
  const companyCode = searchParams.get('companyCode');

  return (
    <Box>
      <Stack>
        <StyledText onClick={() => setOpenDialog(true)} variant="link">
          {props.item.value}
        </StyledText>

        <Stack direction="row">
          <StyledTextSub>
            {`${translate('BidLifeCycle.Version')} ${props.item.row.version}`}
          </StyledTextSub>

          <IconButton
            data-testid="gds-vp-ss-header-linkTOvp"
            onClick={() => {
              if (props.item.row.source === 'COP') {
                window.open(
                  `/vendor-program/details-page?dealid=${props.item.row.bidId}&customerset_id=${props.item.row.customerSetId}&countryCode=${countryCode}&companyCode=${companyCode}`
                );
              } else {
                window.open(
                  `/vendor-program/exception-deal-details?dealNumber=${encodeURIComponent(
                    props.item.row.bidNumber
                  )}&dealid=${props.item.row.bidId}&customerset_id=${
                    props.item.row.customerSetId
                  }&countryCode=${countryCode}&companyCode=${companyCode}`
                );
              }
            }}
            sx={{ padding: '0px 4px' }}
          >
            <LaunchIcon
              sx={(theme) => ({
                color: theme.palette.primary[700],
                fontSize: '18px',
              })}
            />
          </IconButton>
        </Stack>
      </Stack>
      <Dialog
        data-testid="gds-blc-Dialog"
        onClose={() => setOpenDialog(false)}
        open={openDialog}
        sx={{
          '.MuiPaper-root': { minWidth: 'calc(100% - 250px)' },
        }}
      >
        <DialogTitle sx={{ fontSize: '18px', lineHeight: '28px' }}>
          {`${translate('BidLifeCycle.DetailsHeading')} - ${
            props.item.row.bidNumber
          }`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'div'}></DialogContentText>
          <BidDetails row={props.item.row} />
        </DialogContent>
        <DialogActions>
          <Button
            data-testid="gds-vp-popover-dialog-close"
            onClick={() => setOpenDialog(false)}
            variant="newContained"
          >
            {translate('Common.Close')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
